import React from 'react';

const Empty = () => {
  return (
    <>
      <p
        className="nothing-to-show__text"
        style={{ textAlign: 'center', width: '100%', marginTop: 30 }}
      >
        Nothing to show
      </p>
      <div
        className="nothing-to-show__img"
        style={{ display: 'flex', justifyContent: 'center', width: '100%' }}
      >
        <img
          style={{ maxWidth: 650 }}
          src="/img/nothing-to-show.svg"
          alt="nothing-to-show"
        />
      </div>
    </>
  );
};

export default Empty;
